import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';
import redTrafficLight from '../../../assets/img/status/03_ampelwide-rot.png';
import greenTrafficLight from '../../../assets/img/status/01_ampelwide-gruen.png';
import next_arrow from '../../../assets/img/welcome/carousel_right.png';
import prev_arrow from '../../../assets/img/welcome/carousel_left.png';

import Timeline, { customArrow } from '.';

import { matchMaxWidth } from '../../../utils/styles';

import screens from '../../../assets/styles/mixins/_screens.scss';

const NextArrow = customArrow(next_arrow, 'next', styles);
const PrevArrow = customArrow(prev_arrow, 'prev', styles);

const sliderSettings = (isVertical) => (initialSlide) => ({
  dots: false,
  infinite: false,
  initialSlide: initialSlide,
  slidesToShow: 3,
  slidesToScroll: 1,
  vertical: isVertical,
  verticalSwiping: isVertical,
  useTransform: false,
  className: styles['timeline__content-slider'],
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
});

// const header = 'Deine Timeline';

class TroyTimeline extends React.Component {
  constructor() {
    super();
    this.state = {
      matchesMobile: matchMaxWidth(screens.mobileWidth).matches,
      matchesTablet: matchMaxWidth(screens.tabletWidth).matches,
    };
  }

  handleMatchChange = (fieldName) => (e) => {
    this.setState({ [fieldName]: e.matches });
  };

  componentDidMount() {
    matchMaxWidth(screens.mobileWidth).addEventListener(
      'change',
      this.handleMatchChange('matchesMobile')
    );
    matchMaxWidth(screens.tabletWidth).addEventListener(
      'change',
      this.handleMatchChange('matchesTablet')
    );
  }

  render() {
    const { items, blur, isClientPortal, liabilityStatus } = this.props;
    const { matchesMobile, matchesTablet } = this.state;

    const active = (items || []).indexOf(
      (items || []).find(({ current }) => current)
    );
    const isPaidFully =
      liabilityStatus && liabilityStatus.traffic_light === 'GREEN';

    return (
      <Timeline
        {...{
          items,
          blur,
          styles,
          isClientPortal,
          isPaidFully,
        }}
        headPic={isPaidFully ? greenTrafficLight : redTrafficLight}
        sliderSettings={sliderSettings(matchesMobile)(
          active !== -1 ? active - 1 : undefined
        )}
        maxWordLength={matchesTablet ? 10 : 20}
      />
    );
  }
}

TroyTimeline.propTypes = {
  items: PropTypes.array,
  translations: PropTypes.object,
  blur: PropTypes.bool,
};

export default TroyTimeline;

// active !== -1 ? active - 1 : undefined;
